import React, { Component } from "react";
import { HeaderFilter } from "../../../common/header-filter/header-filter.component";
import { connect } from 'react-redux';
const dropdownItem=["Item 1","Item 2", "Item 3"];

const listItem = [
    {
        listTitle: "Circuit",
        href:"/Internal/Inventory/Circuit"
    }        
    ,{
        listTitle: "Equipment"
        , href:"/Internal/Inventory/Equipment"
    }
    ,{
        listTitle: "ASPU"
        , href:"/Internal/Inventory/ASPU"
    } ,{
        listTitle: "ASR"
        , href:"/Internal/Inventory/ASR"
    }
];

const filtersub=[
    {key:31,
    value:"Change Location Address"},
    {key:5,value:"Change Price Plan"},
    {key:4,value:"Change User"},
    {key:14,value:"Change Vendor"},
    {key:29,value:"Change Vendor"},
    {key:27,value:"New Circuit"},
    {key:9,value:"New Mobile Subscription"},
    {key:32,value:"Other"}];

const filterData = [
    {
        id:1,
        filterTitle:"Item 1",
        
    },
    {
        id:2,
        filterTitle:"Item 2",              
    },
    {
        id:3,
        filterTitle:"Item 3",              
    }, {       
        id:4,        
        filterTitle:"Item 4 with Checkbox",              
    }
]

class InventoryEquipment extends Component {
    render() {
        return(
            <HeaderFilter enableDropdown={false} dropdownItem={dropdownItem} enableFilterBtn={true} filterData={filterData} filtersub={filtersub} enableExportExcel={false} btnAddTitle="Add Plan" 
                enableAddBtn={true} enableUploadBtn={false} listItem={listItem} haveTab={true}/>
        )
    }
}

export default connect()(InventoryEquipment);